import { formatDate, formatNumber } from '@angular/common';
import { Injectable } from '@angular/core';
import { find, get } from 'lodash';
import { SessionService } from '../session.service';
import { UtilService } from '../util/util.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  constructor(
    private sessionSvc: SessionService,
    private utilSvc: UtilService
  ) { }

  // This function accepts customer data and a field and returns the formatted value of the field
  formatData(field: any, value: any, log: boolean = false): String {
    
    let type: String = field._type;

    if (log)
      console.log("formatData base", "field", field, "value", value);

    let _formatData = (_value: any) => {
      //console.log("_formatData", "_value", _value)
      switch(type){
        case "Integer": case "Integer[]":
          return _value != null && _value !== undefined ? (field.format != undefined && field.format != "" ? formatNumber(parseInt(_value), 'en-US', field.format) : _value.toString()) : "-";
        case "Float":
          return _value != null && _value !== undefined ? (field.format != undefined && field.format != "" ? formatNumber(parseFloat(_value), 'en-US', field.format) : _value.toString()) : "-";
        case "String": case "String[]":
          let str = String(_value).toString();
          return str != "" ? str : "-";
        case "Boolean":
          return _value ? "Yes" : "No";
        case "Date":
          return this.utilSvc.formatDate(_value);
        case "Object":
          return "Object";
      }
      return _value != null && _value !== undefined ? _value : "-"
    }

    let getSingle = (_value: any): any => {

      //console.log("formatData.getSingle", _value)

      // If the column has options, display the label of the option
      if(field.options !== undefined && field.options.length > 0){
        let option = find(field.options, {"value": _value});
        return option !== undefined && option !== null ? option.label : "No Opt: " + _value;
      }

      // If the column has a reference to an internal record, display the name of the record
      else if(field.ref !== undefined){
        switch(field.ref.type){
          case "facility":
            let facility = find(this.sessionSvc.facilitiesValue, {"foreign_id": _value.toString()});
            if(facility !== undefined && facility !== null){
              return facility.name
            }
            break;
        }
        return "Bad Ref: " + field.ref.type + " (" + _value.toString() + ")";
      }

      return _formatData(_value)
    }

    // An array of values
    if(type.indexOf("[]") > -1 && value !== undefined && value !== null){

      //console.log("formatData[]", JSON.stringify(value))

      if(value.length === 0){
        return "-";
      }

      return value.map((v: any) => {
        return getSingle(v);
      }).join(", ");

    // A single value
    } else if(value !== undefined && value !== null){
      return getSingle(value);
    }

    return "-"
  }

}
